import React, { useState, useMemo } from 'react';
import { Dropdown, Button, ButtonGroup, Form } from '../ui-kit';

const contractUrl = (userId, startTime, endTime, periodType, timeUnit) =>
  `/users/${userId}/reporting/contracts/contracts?end_time=${endTime}&period_type=${periodType}&start_time=${startTime}&time_unit=${timeUnit}`;

const UserDropdownBreadcrumb = ({ user, userList, startTime, endTime, periodType, timeUnit }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const userListAugmented = useMemo(
    () =>
      userList.map(u => ({
        url: contractUrl(u.id, startTime, endTime, periodType, timeUnit),
        ...u
      })),
    []
  );

  const filteredOptions = userListAugmented.filter(e => e.name.toLowerCase().includes(searchQuery.toLowerCase()));

  return (
    <Dropdown as={ButtonGroup} size="sm">
      <Button variant="outline-secondary" href={`/users/${user.id}`}>
        {user.name}
      </Button>
      <Dropdown.Toggle split size="sm" variant="outline-secondary" />
      <Dropdown.Menu>
        <Form.Control
          autoFocus
          className="mx-3 my-2 w-auto"
          placeholder={I18n.t('search')}
          onChange={e => setSearchQuery(e.target.value)}
          value={searchQuery}
        />
        <div className={'overflow-y-scroll'} style={{ maxHeight: '300px' }}>
          {filteredOptions.map(option => (
            <Dropdown.Item key={option.id} href={option.url} eventKey={option.id}>
              {option.name}
            </Dropdown.Item>
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default UserDropdownBreadcrumb;
